import type {RouteRecordRaw} from 'vue-router'
import PageWrapper from '@/components/common/PageWrapper.vue'
import constants from '@/constants'

const routes: RouteRecordRaw[] = [
  {
    path: '/',
    component: PageWrapper,
    meta: {
      requiresAuth: true
    },
    children: [
      {
        path: '',
        name: constants.DASHBOARD,
        component: () => import('@/views/MachineDashboardSwitch.vue')
      },
      {
        path: 'options',
        name: constants.BUILD_OPTIONS,
        component: () => import('@/views/BuiltOptions.vue')
      },
      {
        path: 'manuals',
        name: constants.MANUALS,
        component: () => import('@/views/MachineManuals.vue')
      },
      {
        path: 'schematics',
        name: constants.SCHEMATICS,
        component: () => import('@/views/MachineSchematics.vue')
      },
      {
        path: 'warranty',
        name: constants.WARRANTY,
        component: () => import('@/views/MachineWarranty.vue')
      },
      {
        path: 'locationhistory',
        name: constants.LOCATION_HISTORY,
        component: () => import('@/views/LocationHistory.vue')
      },
      {
        path: 'maintenance',
        name: constants.MAINTENANCE_SCHEDULE,
        component: () => import('@/views/MaintenanceSchedule.vue')
      },
      {
        path: 'faultcodes',
        name: constants.FAULT_CODES,
        component: () => import('@/views/FaultCodes.vue')
      },
      {
        path: 'fieldmods',
        name: constants.FIELD_MODIFICATIONS,
        component: () => import('@/views/FieldMods.vue')
      },
      {
        path: 'troubleshooting',
        name: constants.TROUBLESHOOTING,
        component: () => import('@/views/Troubleshooting/TroubleshootingPage.vue')
      },
      {
        path: 'history',
        name: constants.DIAGNOSTIC,
        component: () => import('@/views/ServiceHistory.vue')
      },
      {
        path: 'controller-versions',
        name: 'Controller Versions',
        component: () => import('@/views/ControllerVersions.vue')
      },
      {
        path: 'sessionadmin',
        name: constants.SESSIONS_ADMIN,
        meta: {
          hideSidebar: true
        },
        component: () => import('@/views/TroubleshootingAdmin.vue')
      },
      {
        path: 'opensession',
        name: constants.MY_SESSIONS,
        meta: {
          hideSidebar: true
        },
        component: () => import('@/views/OpenSessions.vue')
      }
    ]
  },
  {
    path: '/error',
    name: constants.ERROR,
    component: () => import('@/views/ErrorLandingPage.vue')
  }
]

export default routes